import { Pipe, PipeTransform } from '@angular/core';
import { PatientDetails } from '@ffd/api-client';
import { Person } from '@libs/ui-lib';

@Pipe({ name: 'libPatientsToPersons', pure: true, standalone: true })
export class PatientToPersonPipe implements PipeTransform {
  public transform(patients: PatientDetails[]): Person[] {
    return patients.map((patient) => ({
      firstName: patient.firstName,
      lastName: patient.lastName,
      avatarUrl: null,
    }));
  }
}
